export default "__VITE_ASSET__CVaJXUGg__"